"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = assertString;
function assertString(value) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  if (typeof value !== 'string') {
    throw new TypeError("".concat(label, " needs to be a string"));
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/utils/assertString.js
// module id = 1881
// module chunks = 0